<template>
    <div class="confirmMessageBox" v-show="isShowMessageBox">
      <div class="mask"></div>
      <div class="box" :style="{width}">
        <i class="closeIcon el-icon-close" @click="cancel()"></i>
        <h3 class="title">{{title}}</h3>
        <div class="content" v-html="content"></div>
        <div class="foot">
          <el-button v-if="btnText" class="btn" type="primary" @click="confirm(true)">{{btnText}}</el-button>
          <el-button v-if="cancelText" class="btn" @click="cancel()">{{cancelText}}</el-button>
        </div>
      </div>
    </div>
</template>
    
  
<script>
export default {
    props: {
      width: {
        type: String,
        default: "500px"
      },
      title: {
        type: String,
        default: "提示"
      },
      content: {
        type: String,
        default: ""
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      btnText: {
        type: String,
        default: '确定'
      },
    },
    created(){
      
    },
    data() {
      return {
          isShowMessageBox: false,
          resolve: '',
          reject: '',
          promise: '', // 保存promise对象
          
      };
    },
    methods: {
      // 确定,将promise断定为resolve状态
      confirm: function (row) {
        this.isShowMessageBox = false;
        if(row){
          this.resolve(row);
        }else{
          this.resolve(this.activeArr);
        }
        this.remove();
      },
      // 取消,将promise断定为reject状态
      cancel: function () {
        this.isShowMessageBox = false;
        this.reject('cancel');
        this.remove();
      },
      // 弹出messageBox,并创建promise对象
      confirmMessageBox: function () {
        this.isShowMessageBox = true;
        this.promise = new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
        return this.promise;
      },
      remove: function () {
        setTimeout(() => {
          this.destroy();
        }, 300);
      },
      destroy: function () {
        this.$destroy();
        document.body.removeChild(this.$el);
      }
    }
};
</script>
<style lang="scss">
.confirmMessageBox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  margin: auto;
  z-index: 999;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    margin: auto;
    background: rgba($color: #000000, $alpha: 0.25);
  }
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding:25px 100px 35px  100px;
    border-radius: 5px;
    background: #fff;
    color: #27252B;
    .closeIcon {
      position: absolute;
      top: 6px;
      right: 6px;
      font-size: 18px;
      z-index: 9;
      cursor: pointer;
    }
    .title {
      min-height: 30px;
      padding-bottom: 15px;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
    .content {
      padding-bottom: 30px;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
      //误删：有用
      table{width:100%; border-collapse:collapse;}
	    th,td{ border:1px solid black;padding:10px;}
    }
    .foot{
      display: flex;
      justify-content: center;
      .btn {
        width: 150px;
        height: 34px;
        padding: 0;
        line-height: 30px;
      }
    }
  }
}
</style>